 enum Page {
  NOT_FOUND, HOME, SEARCH, BOOK, REDIRECT 
}

export default Page